import React, { Component } from "react"
import { Modal, Button } from "react-bootstrap"
import ReactQuill from "react-quill-v2.0"
import IconBuilder from "src/utilities/iconBuilder/IconBuilder"
import reggie from "src/utilities/Reggie"
//@ts-ignore
import FileTypes from "../FileTypes"
import "./DocAnnotator.css"

interface Props {
  manageParentState: Function
  files: Array<FileTypes>
  annotationDex: number
}

interface State {
  input: string | null
}

class DocAnnotator extends Component<Props, State> {

   formats = ["font", "color", "header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link"]

  state = {
    input: null
  }

  componentDidMount(){
    this.setState({ input: this.props.files[this.props.annotationDex].noteText })
  }

  handleQuill = (event: any) => {
    let input = event
    if (reggie.filterTags(input) === "") {
      input = null
    }
    this.setState({ input: input })
  }

  appendText = () => {
    let files = this.props.files
    const index = this.props.annotationDex
    files[index].noteText = this.state.input
    this.props.manageParentState([{ key: "files", value: files }, { key: "annotationDex", value: -1 }])
  }

  render() {

    const state = this.state
    const props = this.props
    const file = props.files[this.props.annotationDex]

    return (
      <div className="DocAnnotator">
        <Modal id="doc-annotator-modal"
          show={true}
          backdrop="static"
          keyboard={true}
          centered={true}
          size="lg"
        >
          <Modal.Header>
            <div className="DocAnnotatorModalHeader">
              <div className="DocAnnotatorModalHeaderIcon">
                <IconBuilder
                  extension={file.extension}
                  size={48}
                />
              </div>
              <div className="DocAnnotatorModalHeaderTitle">
                <p>{file.displayName}</p>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="DocAnnotatorModalBody">
              <ReactQuill
                value={this.state.input || ""}
                onChange={(e) => this.handleQuill(e)}
                formats={this.formats}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="DocAnnotatorModalFooter">
              <Button variant="secondary" onClick={() => this.props.manageParentState([{ key: "annotationDex", value: -1 }])} >Back</Button>
              {state.input && <Button onClick={() => this.appendText()}>Ok</Button>}
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default DocAnnotator